import {FC, useState} from 'react'
import Swal from 'sweetalert2'
import {KTIcon} from '../../../../../_metronic/helpers'
import {DownloadRequestItem} from '../../core/_models'
import {downloadRequest} from '../../core/_requests'
import {useConfig} from '../../ConfigContext'

type Props = {
  row: DownloadRequestItem
}

const ActionsCell: FC<Props> = ({row}) => {
  const [loading, setLoading] = useState(false)
  const {isKpi} = useConfig()

  if (row.status !== 'ready') return <span className='text-muted'>-</span>

  const handleDownload = async () => {
    setLoading(true)
    try {
      await downloadRequest(row.id, isKpi)
    } catch (err: any) {
      Swal.fire({
        icon: 'error',
        title: 'Erro',
        text: err?.response?.data?.message ?? 'Não foi possível realizar o download.',
        confirmButtonColor: '#d33',
      })
    } finally {
      setLoading(false)
    }
  }

  return (
    <button
      type='button'
      className='btn btn-icon btn-light-success btn-sm'
      disabled={loading}
      onClick={() => void handleDownload()}
      title='Baixar arquivo'
    >
      {loading ? (
        <span className='spinner-border spinner-border-sm' />
      ) : (
        <KTIcon iconName='exit-down' className='fs-3' />
      )}
    </button>
  )
}

export {ActionsCell}